import React from "react";
import { Container, makeStyles, Paper, Typography } from "@material-ui/core";

const configs = require("../configs.json");

const styles = (theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  paperContainer: {
    borderRadius: theme.spacing(2),
    padding: theme.spacing(5),
    maxWidth: 500,
    width: "100%",
  },
  title: {
    textAlign: "center",
    fontWeight: 600,
    padding: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
  },
});

const useStyles = makeStyles(styles);

function CommingSoonPage({ darkMode }) {
  const classes = useStyles();
  return (
    <Container className={classes.container}>
      <Paper elevation={0} className={classes.paperContainer}>
        <img
          src={
            darkMode && configs.theme.logo.smallLogoLight
              ? configs.theme.logo.smallLogoLight
              : configs.theme.logo.smallLogo
          }
          alt="logo"
          className="d-block m-auto mb-4 big-simple-logo"
        />
        <Typography variant="h5" className={classes.title}>
          Comming Soon{" "}
        </Typography>{" "}
      </Paper>{" "}
    </Container>
  );
}

export default CommingSoonPage;
